import { CompProps } from '@fable/types'
import { useCallback } from 'react'
import { useReadingGoals } from './lib/ctx/reading_goals'
import { ReadingGoalPeriodType } from './lib/types'
import { css } from '@fable/theme'
import { registerFableScript } from 'app/webview/utils'
import { scroller } from 'react-scroll'

export const StatsScroll = ({ children }: CompProps) => {
  const setPeriod = useReadingGoals((s) => s.setPeriod)

  const onScrollToHash = useCallback((id: string) => {
    scroller.scrollTo(id, {
      duration: 600,
      smooth: 'easeInOutQuad',
      offset: -80,
    })
  }, [])

  const scrollToGoals = useCallback(
    (period: string) => {
      onScrollToHash('reading-goals')

      setPeriod(period as ReadingGoalPeriodType)
    },
    [onScrollToHash, setPeriod]
  )

  if (!window.fableScripts) {
    window.fableScripts = {}
  }

  // Register to window.fableScripts
  registerFableScript('scrollToGoals', scrollToGoals)

  return (
    <div
      className={css`
        width: 100%;
      `}
    >
      {children}
    </div>
  )
}
